export const FALLBACK_STRING_NA = 'N/A'
export const FALLBACK_STRING_DASH = '—'

export const NO_ERROR_MESSAGE = 'No error message could be found.'
export const MISSING = 'MISSING'
